module.exports = __webpack_public_path__ + "static/media/menorah.b0d85bee.svg";